
export default {
    namespaced: true,
    state: {
        sitesData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        typeList: [],
        yandexRegionList: [],
        googleRegionList: [],
        isSendingSAVE: false,
        timerSAVE: null,
        existChange: false,
        selectedType: 'en_ru',
        params: {
            groupFilter: null,
            search: null,
            sort: {
                dir: 'asc',
                field: 'id'
            }
        },
        deletedList: [],
        searchNumberSum: 'н/д',
        groups: []
    },
    getters: {
        GET_PREPARE_PARAMS: state => {
            return {
                'page': state.currentPage,
                'pageSize': state.perPage <= 0 ? 1 : state.perPage,
                'search': state.params.search,
                'sort': state.params.sort.field,
                'sortDir': state.params.sort.dir,
                'groupFilter': state.params.groupFilter
            };
        },
        YANDEX_REGION_LIST: state => {
            return state.yandexRegionList;
        },
        SEARCH_NUMBER_SUM: state => {
            return state.searchNumberSum;
        },
        GOOGLE_REGION_LIST: state => {
            return state.googleRegionList;
        },
        DELETED_LIST: state => {
            return state.deletedList;
        },
        PARAMS: state => {
            return state.params;
        },
        SELECTED_TYPE: state => {
            return state.selectedType;
        },
        EXIST_CHANGE: state => {
            return state.existChange;
        },
        SITES_DATA: state => {
            return state.sitesData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
        GROUPS: state => {
            return state.groups;
        },
    },
    mutations: {
        SEARCH_NUMBER_SUM: (state, payload) => {
            return state.searchNumberSum = payload;
        },
        YANDEX_REGION_LIST: (state, payload) => {
            return state.yandexRegionList = payload;
        },
        GOOGLE_REGION_LIST: (state, payload) => {
            return state.googleRegionList = payload;
        },
        DELETED_LIST: (state, payload) => {
            return state.deletedList = payload;
        },
        ADD_TO_DELETED_LIST: (state, payload) => {
            return state.deletedList.push(payload);
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        SELECTED_TYPE: (state, payload) => {
            return state.selectedType = payload;
        },
        EXIST_CHANGE: (state, payload) => {
            return state.existChange = payload;
        },
        SITES_DATA: (state, payload) => {
            return state.sitesData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        GROUPS: (state, payload) => {
            return state.groups = payload;
        },
    },
    actions: {
        SAVE: async ({commit, state, dispatch, getters}, payload) => {
            if (state.isSendingSAVE) {
                if (state.timerSAVE != null) {
                    clearTimeout(state.timerSAVE);
                }
                state.timerSAVE = setTimeout(() => {
                    state.timerSAVE = null;
                    dispatch('SAVE', {th: payload.th});
                }, 2000);
            } else {
                let data = {
                    list: state.sitesData,
                    deleted: state.deletedList,
                    params: getters.GET_PREPARE_PARAMS
                };
                state.isSendingSAVE = true;
                payload.th.showOverlay ++;
                await payload.th.$store.dispatch('SEND_POST', {
                    url: '/sites',
                    parameter: data,
                    th: payload.th,
                    showSuccessMessage: false,
                    getSuccessResponse: (responseData) => {
                        state.deletedList = [];
                        // prepare value
                        for (let key in responseData.data.list) {
                            let val = responseData.data.list[key]
                            if (val == undefined || val == null)
                                continue
                            if (val.brands == '') {
                                responseData.data.list[key].brands = [];
                            }
                            if (val.tags == '') {
                                responseData.data.list[key].tags = [];
                            }
                            if (val.searchEngines == '') {
                                responseData.data.list[key].searchEngines = [];
                            }
                        }

                        commit('SITES_DATA', responseData.data.list);
                        commit('TOTAL_ROWS', responseData.data.count);
                        commit('EXIST_CHANGE', false);
                        commit('SEARCH_NUMBER_SUM', responseData.data.searchNumberSum);
                    },
                    getResponse: () => {
                        state.isSendingSAVE = false;
                        payload.th.showOverlay --;
                    }
                });
            }
        },
        GET_YANDEX_REGIONS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            let params = {
                'searchEngine': 'yandex',
            }
            params = JSON.stringify(params);
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/search-region-names?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('YANDEX_REGION_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_GOOGLE_REGIONS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            let params = {
                'searchEngine': 'google',
            }
            params = JSON.stringify(params);
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/search-region-names?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GOOGLE_REGION_LIST', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_DATA: async ({commit, getters}, payload) => {
            let params = getters.GET_PREPARE_PARAMS;
            params = JSON.stringify(params);
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/sites?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // prepare value
                    for (let key in responseData.data.list) {
                        let val = responseData.data.list[key]
                        if (val == undefined || val == null)
                            continue
                        if (val.brands == '') {
                            responseData.data.list[key].brands = [];
                        }
                        if (val.searchEngines == '') {
                            responseData.data.list[key].searchEngines = [];
                        }
                    }
                    commit('SITES_DATA', responseData.data.list);
                    commit('TOTAL_ROWS', responseData.data.count);
                    commit('SEARCH_NUMBER_SUM', responseData.data.searchNumberSum);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },

        RECOUNT: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/sites/recount',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    payload.th.GET_DATA({th: payload.th})
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay --;
                }
            });
        },
        GET_GROUPS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-groups',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GROUPS', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
    }
}